export const phoneFieldStyle = {
  width: '100%',
  height: '3.7rem',
};
